import axiosInstance from '@/api/axiosInstance';
import { globalState } from '@/globalState';

let inFlight = null;
let cacheValue = null;
let cacheKey = null;
let cacheAt = 0;

function buildKey(includeStyles) {
  return includeStyles === true ? 'includeStyles=1' : 'includeStyles=0';
}

function buildUrl(includeStyles) {
  const base = `${globalState.apiEndpoint}/getAllAIChats`;
  if (includeStyles === true) {
    return `${base}?includeStyles=1`;
  }
  return base;
}

export async function getAllAIChats(options = {}) {
  const includeStyles = options.includeStyles === true;
  const force = options.force === true;
  const ttlMs = typeof options.ttlMs === 'number' && options.ttlMs >= 0 ? options.ttlMs : 1200;
  const key = buildKey(includeStyles);
  const now = Date.now();

  if (force === false && cacheValue !== null && cacheKey === key && (now - cacheAt) <= ttlMs) {
    return cacheValue;
  }

  if (inFlight !== null && inFlight.key === key) {
    return inFlight.promise;
  }

  const url = buildUrl(includeStyles);
  const promise = axiosInstance.get(url).then((response) => {
    cacheValue = response.data;
    cacheKey = key;
    cacheAt = Date.now();
    return cacheValue;
  }).finally(() => {
    if (inFlight !== null && inFlight.key === key) {
      inFlight = null;
    }
  });

  inFlight = { key, promise };
  return promise;
}

export function invalidateAllAIChatsCache() {
  cacheValue = null;
  cacheKey = null;
  cacheAt = 0;
  inFlight = null;
}















